/* eslint-disable max-classes-per-file */
import { React, withI18nHelper, WithPopoverManager, IPopoverManager } from '@@commons';
import { ItemsPicker } from '../itemspicker';
import { DropdownEditorPopover } from './popover';

import './dropdowneditor.less';
import { Entities } from '@inwink/entities/entities';

export interface IDropdownEditorProps {
    selection: IDropdownEditorItem[];
    allItems: IDropdownEditorItem[];
    onChange: (selection: IDropdownEditorItem[]) => void;
    modaleTitle?: string | ((props?: any) => any);
    buttonItemPickerI18nTrad?: string;
    onUpdateItem?: (item: any) => void | Promise<void>;
    multiselect?: boolean;
    readOnly?: boolean;
    disableRemove?: boolean;
    className?: string;
    prefixFilterTokenToIgnore?: string;
    configureItemsOnClick?: () => Promise<boolean>;
    entityFieldFormTemplate?: Entities.IExtendedFieldsFormFieldTemplate;
}

interface IDropdownEditorState {
}

export interface IDropdownEditorItem {
    label: string;
    key: string;
    dataTrad?: string;
    disableSelectable?: boolean;
    className?: string;
}

@withI18nHelper()
export class DropdownEditor extends React.Component<IDropdownEditorProps, any> {
    render() {
        return <WithPopoverManager>
            {(popovermgr) => <DropdownEditorContent {...this.props} popovermgr={popovermgr} />}
        </WithPopoverManager>;
    }
}

export interface IDropdownEditorContentProps extends IDropdownEditorProps {
    popovermgr: IPopoverManager;
}

class DropdownEditorContent extends React.Component<IDropdownEditorContentProps, IDropdownEditorState> {
    popover: any;

    componentDidUpdate() {
        if (this.popover) {
            this.popover.setProps(this.props);
        }
    }

    renderItem(item: IDropdownEditorItem) {
        if (item.dataTrad) {
            return <span data-trad={item.dataTrad} className="dropdowneditor-selecteditem">{item.label}</span>;
        }
        return <span className="dropdowneditor-selecteditem">{item.label}</span>;
    }

    pick = (arg: React.MouseEvent<any>) => {
        const popover = pickItems(arg.currentTarget, this.props);
        this.popover = popover;
        popover.then(() => {
            this.popover = null;
        });
    };

    removeItem = (item) => {
        const selection = this.props.selection.filter((s) => s.key !== item.key);
        this.props.onChange(selection);
    };

    render() {
        return <ItemsPicker
            className={"iw-bo-dropdowneditor" + (this.props.className ? " " + this.props.className : "")}
            updateButtonI18nTrad={this.props.buttonItemPickerI18nTrad}
            itemsRenderer={this.renderItem}
            onPick={this.pick}
            onUpdateItem={this.props.onUpdateItem}
            onRemoveItem={this.props.disableRemove ? null : this.removeItem}
            selection={this.props.selection}
            readOnly={this.props.readOnly}
        />;
    }
}

export function sortItems(a: IDropdownEditorItem, b: IDropdownEditorItem) {
    if (b.label.toLowerCase() < a.label.toLowerCase()) {
        return 1;
    }
    if (b.label.toLowerCase() > a.label.toLowerCase()) {
        return -1;
    }
    return 0;
}

export function pickItems(elt: HTMLElement, props: IDropdownEditorContentProps) {
    return props.popovermgr.popoverPortal(elt,
        DropdownEditorPopover, props, "iw-dropdowneditor-popover");
    
} 